import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  text-align: center;
  position: fixed;
  bottom: 20px;
  width: 100%;
`;

const Footer = () => {
  return <Wrap>Copyright ©2018</Wrap>;
};

export default Footer;
